<template>
  <div :style="{height: documentHeight + 'px'}">

    <!-- 预览头部容器 -->
    <div v-if="previewCmp != PREVIEW_CMP.OFFICE" class="preview">
      <!-- 文件标题 -->
      <div class="title">
        <span class="icon"></span>
        <span class="file-name">{{ fileName }}</span>
        <span class="file-size">{{ bytesToSize(fileSize) }}</span>
        <span class="download-path">[<a :href="downloadUrl" target="_blank">{{$t("wm_lang_html_f26ef9")}}</a>]</span>
      </div>
    </div>

    <!-- 可预览附件使用组件预览 -->
    <div v-if="previewCmp == PREVIEW_CMP.OFFICE" id="previewContainerId" style="height: 100%"></div>

    <!-- 需要自己解析的附件预览 -->
    <iframe v-else-if="previewCmp == PREVIEW_CMP.IMG || previewCmp == PREVIEW_CMP.TXT || previewCmp == PREVIEW_CMP.HTML"
            :style="{height: (documentHeight - 45) + 'px'}" class="frame" :src="previewUrl"></iframe>

    <!-- 文件大小超限制 -->
    <div v-else-if="previewCmp == PREVIEW_CMP.SIZE_LIMIT" class="preview-tip">
      <span>{{$t("wm_lang_html_ecda36")}}!</span>
    </div>

    <!-- 不可预览附件类型给出提示 -->
    <div v-else class="preview-tip">
      <span>{{$t("wm_lang_html_9ef98a")}}(Sorry, this file does not support preview temporarily)!</span>
    </div>

  </div>
</template>

<script>
import {bytesToSize, loadJs} from '@/utils/utils';

export default {
  components: {},
  name: 'AttachPreview',
  data() {
    return {
      PREVIEW_CMP: {
        OFFICE: 1,     // onlyOffice预览
        IMG: 2,        // 图片预览
        TXT: 3,        // 文本预览
        HTML: 4,       // HTML预览
        SIZE_LIMIT: 5  // 大小超限制
      },
      previewServerOnOff: true,    // 预览服务开关
      previewCmpType: '',          // 预览组件类型
      previewCmp: '',              // 预览组件
      downloadUrl: '',             // 下载url
      previewUrl: '',              // 预览url
      fileName: '',                // 文件名称
      fileSize: 0,                 // 文件大小
      previewServerDomainName: '', // 预览服务名称
      icon: ''                     // icon图标
    }
  },
  methods: {
    // 格式化文件大小
    bytesToSize(bytes) {
      return bytesToSize(bytes)
    },
    // 验证预览文件大小
    checkFileSizeLimit() {
      return this.fileSize > 20 * 1024 * 1024;
    }
  },
  computed: {
    // 文档高度
    documentHeight: function () {
      return window.innerHeight;
    }
  },
  mounted() {
    this.downloadUrl = this.$route.query.downloadUrl;
    this.previewUrl = this.$route.query.previewUrl;
    this.fileName = this.$route.query.attachName;
    this.fileSize = this.$route.query.attachSize;
    this.previewServerDomainName = this.$route.query.previewServerDomainName;
    this.previewServerOnOff = this.$route.query.previewServerOnOff === "1" ? true : false;
    let fId = this.$route.query.attachId;
    let fType = this.fileName.split('.').pop();

    console.log("==============================================")
    console.log(this.$route.query.previewServerOnOff)

    // 验证文件大小
    if (this.checkFileSizeLimit()) {
      this.previewCmp = this.PREVIEW_CMP.SIZE_LIMIT;
      return;
    }

    let docType = '';
    switch (fType) {
      case 'doc':
      case 'docx':
      case 'pdf':
        docType = 'word';
        break;
      case 'xls':
      case 'xlsx':
        docType = 'cell';
        break;
      case 'ppt':
      case 'pptx':
        docType = 'slide';
        break;
      default:
        docType = 'unKnow'
    }
    if (docType != '' && docType != 'unKnow') {
      this.previewCmp = this.PREVIEW_CMP.OFFICE;
    }
    console.log("fType=" + fType)
    console.log("fId=" + fId)
    console.log("fileName=" + this.fileName)
    console.log("docType=" + docType)

    // DocsAPI 支持预览的格式
    if (this.previewCmp == this.PREVIEW_CMP.OFFICE) {

      // 是否使用组件预览文档
      if (this.previewServerOnOff) {
        loadJs(this.previewServerDomainName +"/web-apps/apps/api/documents/api.js").then(() => {
          window.docEditor = new DocsAPI.DocEditor("previewContainerId",
            {
              "document": {
                "fileType": fType,
                "key": fId,
                "title": this.fileName,
                "url": this.downloadUrl + "&t=" + new Date().getTime()
              },
              "documentType": docType,
              "editorConfig": {
                "mode": "view"
              },
              "height": "100%",
              "width": "100%"
            });
        });
      } else {
        this.previewCmp = '';
      }
    }
    // 自定义组件预览
    else {
      if (fType == 'png' || fType == 'jpg' || fType == 'jpeg' || fType == 'gif' || fType == 'bmp' || fType == 'tif' || fType == 'tiff') {
        this.previewCmp = this.PREVIEW_CMP.IMG;
      } else if (fType == 'txt') {
        this.previewCmp = this.PREVIEW_CMP.TXT;
      } else if (fType == 'html' || fType == 'htm' || fType == 'xml') {
        this.previewCmp = this.PREVIEW_CMP.HTML;
      }
    }
  }
}
</script>

<style scoped>
.preview {
  width: 100%;
  height: 38px;
  margin: 0;
  background: #f4f8fc;
  border-bottom: 1px solid #b5c6d3;
}

.preview .title {
  width: 100%;
  height: 30px;
  margin: 0;
  padding: 5px 0;
  float: left;
}

.preview span {
  display: inline-block;
  float: left;
}

.preview span.file-name {
  height: 30px;
  line-height: 28px;
  color: #453d37;
  font-size: 16px;
  font-weight: bold;
  margin: 0 5px 0 10px;
}

.preview span.file-size {
  height: 30px;
  line-height: 30px;
  color: #a09f9f;
  font-size: 12px;
  font-family: arial;
}

.preview span.download-path {
  height: 30px;
  line-height: 29px;
  font-size: 12px;
  font-weight: bold;
  margin: 0 10px;
}

.preview-tip {
  width: 100%;
  height: 50px;
  padding-top: 10px;
}

.preview-tip span {
  margin-left: 10px;
  font-size: 16px;
  color: #1a1a1a;
}

.frame {
  width: 100%;
  border: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/views/login/attachPreview.vue